import styled from '@emotion/styled'
import { PAPER_HEIGHTS } from '../theme'

export const LoadingRoot = styled('div')({
    display: 'flex',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: PAPER_HEIGHTS.zero,
})
